<template>
  <auth-wrapper>
    <router-view />
  </auth-wrapper>
</template>

<script>
import AuthWrapper from './layouts/AuthWrapper.vue';

export default {
  components: {
    AuthWrapper
  }
}
</script>